import React from "react";
import { PagingBar } from "./PagingBar";
import usePaging from "./usePaging";
import { pagingType } from "../../../common/types/search/search";

export function Paging({ paging }: { paging: pagingType }) {
	const { currentPage, pages, onPageSelected } = usePaging(paging);

	if (pages <= 1) {
		return null;
	}

	return (
		<PagingBar
			pages={pages}
			currentPage={currentPage}
			onPageSelected={onPageSelected}
		/>
	);
}
